import {
    fetchDeployedMeta,
    getLocalStorageVersion,
    isNewVersionAvailable,
    saveLocalStorageVersion,
} from "../../utils/cacheBusting";
import vgLog from "./vgLog";

export async function checkForUpdates(callback?: () => void): Promise<void> {
  vgLog("checkForUpdates: start");

  try {
    const deployed = await fetchDeployedMeta();

    vgLog("fetched deployed meta", deployed);

    if (!deployed) {
      vgLog("checkForUpdates: no deployed meta available");
      return;
    }

    const deployedVersion = deployed.version;

    const localStorageVersion = getLocalStorageVersion();

    vgLog("versions", { localStorageVersion, deployedVersion });

    // If no localStorage version, this is first load - save it
    if (!localStorageVersion) {
      vgLog("no local version found, saving deployed version", deployedVersion);
      saveLocalStorageVersion(deployedVersion);
      return;
    }

    // Check if versions differ
    const newVersionAvailable = isNewVersionAvailable(
      localStorageVersion,
      deployedVersion,
    );

    vgLog("newVersionAvailable", newVersionAvailable);

    if (newVersionAvailable) {
      // Save new version to localStorage before reload
      vgLog("saving new version to localStorage", deployedVersion);

      saveLocalStorageVersion(deployedVersion);

      if (callback) {
        vgLog("invoking callback due to new version");

        callback();
      }
    }
  } catch (error) {
    vgLog("checkForUpdates: failed", error);
    // Silently fail - don't break the app if version check fails
    // eslint-disable-next-line no-console
    console.warn("Version check failed:", error);
  }
}
